import { transformToHtml } from '../../utils/CommonUtils';
import { footerFareFinderDT } from '../../utils/htmlUtil/htmlFooterDT';

const FooterFareFinderDT = (props) => {
  const { footer_data: footerData } = props?.data || {};
  const footerFareFinder = footerFareFinderDT;
  return (
    <>
      <div id="footer_block">{ footerData ? <footer className="paddingTop30 appendTop30">{transformToHtml(footerData)}</footer> : transformToHtml(footerFareFinder)}</div>
    </>
  );
};

export default FooterFareFinderDT;